export default "__VITE_ASSET__CH5lsX59__"